<template>
  <button
      @click="toggleSave"
      :class="[
      'w-8 h-8 flex items-center justify-center rounded-tr-2xl rounded-bl-2xl shadow transition-colors',
      isSaved ? 'bg-green-500 hover:bg-green-600' : 'bg-white hover:bg-gray-100'
    ]"
  >
    <Icon :name="isSaved ? 'playlist_add_check' : 'playlist_add'" class="text-2xl" :class="isSaved ? 'text-white' : 'text-gray-600'"/>
  </button>
</template>

<script setup>
import { ref, computed } from 'vue'
import {Icon} from "@/components/block/icon";

const props = defineProps({
  challenge: { type: Object, required: true }
})

const emit = defineEmits(['saved', 'unsaved'])

const isSaved = ref(props.challenge.is_saved || false)

const savedState = computed(() => props.challenge.is_saved)

if (savedState.value !== undefined) {
  isSaved.value = savedState.value
}

function toggleSave() {
  if (!isSaved.value) {
    saveChallenge()
  } else {
    unsaveChallenge()
  }
  isSaved.value = !isSaved.value
}

function saveChallenge() {
  emit('saved', props.challenge)
}

function unsaveChallenge() {
  emit('unsaved', props.challenge)
}
</script>